import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    CreditCard
} from "../models";

import moment from "moment";
import momentTimezone from "moment-timezone";

export class CreditCardPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/reservation/:reservationId/credit-card(/:id)';
    }

    newModel(attributes, ...params) {

        return new CreditCard(attributes);
    }

    get(reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,

            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    create(creditCard, reservationId) {

        const url = this.url({
            reservationId: reservationId
        });

        return this.http
            .post(url, creditCard, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(creditCard) {

        const url = this.url({
            reservationId: creditCard.reservation_id,
            id: creditCard.id
        });

        return this.http.put(url, creditCard, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    authAndLoad(credentials, reservationId, id) {

        const url = this.url({
            reservationId: reservationId,
            id: id
        });

        return this.http.post(url + '/auth', credentials, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    checkExpirationDate(month, year, timezone = null) {

        let lastDayOfMonth = moment(`${year}-${month}`, 'YYYY-MM').add(1, 'months').date(0).format('DD');

        let cardExp = moment(`${year}-${month}-${lastDayOfMonth}`, "YYYY-MM-DD");

        let now = moment();

        if (timezone) {

            now = moment(momentTimezone().tz(timezone).format('YYYY-MM-DD HH:mm:ss'));
        }

        const isValid = !cardExp.isBefore(now, 'day');

        return isValid;
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/credit-card.service.js